import { CheckoutLocale } from '@platform-frontend/checkout-drop-in';
import { YattaLangId } from '../model/yatta-lang-id';

export const LANG_TO_LOCALE_MAPPING: Record<YattaLangId, CheckoutLocale> = {
  de: 'de-DE',
  en: 'en-US'
};
